module.exports = __webpack_public_path__ + "static/map-28924d4a015131741965d7c5e5c06dd1.svg";